import { DataTableFacetedFilter } from "../data-table-faceted-filter";
import { DataTableToggleFilter } from "../data-table-slider-filter";
import { FilterType } from "./filter-type";

export const FilterComponentMap = {
  [FilterType.MultiSelect]: DataTableFacetedFilter,
  [FilterType.Toggle]: DataTableToggleFilter,
};
